// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2XmE5","col":"styles_col__IZ3PC","fulfillmentStatus":"styles_fulfillmentStatus__3VfWD","emailCol":"styles_emailCol__tC9Uz"};